export default __webpack_public_path__ + "static/media/staff-management.9263063b.svg";